export default __webpack_public_path__ + "static/media/coal.63d5d552.svg";